<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 单位信息
        </span>
        <div class="normalNav zaddBtn">
          <button class="OrangeSmBtn" @click="edit">编辑</button>
        </div>
        <div class="tableWrapper" v-loading="showTable">
          <!-- 后端分页 -->
          <div class="info" v-if="showFrom">
            <div>单位名称：{{showInfo.name}}</div>
            <div>单位简称：{{showInfo.shortName}}</div>
            <div>区域：{{showInfo.areaTitle}}</div>
            <div>地址：{{showInfo.address}}</div>
            <div>联系人：{{showInfo.contactPerson}}</div>
            <div>联系电话：{{showInfo.contactPhone}}</div>
            <div>工商注册号：{{showInfo.registrationSn}}</div>
            <div>行业类型：{{showInfo.typeName }}</div>
          </div>
          <div v-else>
            <el-form :model="formData" ref="formData" label-width="100px" class="cominfoForm">
              <el-form-item label="单位名称">
                <el-input v-model.trim="formData.name"></el-input>
              </el-form-item>
              <el-form-item label="单位简称">
                <el-input v-model.trim="formData.shortName"></el-input>
              </el-form-item>
              <el-form-item label="区域">
                <el-cascader size="large" :options="options" v-model="formData.areaIds"></el-cascader>
              </el-form-item>
              <el-form-item label="地址">
                <el-input v-model.trim="formData.address"></el-input>
              </el-form-item>
              <el-form-item label="联系人：">
                <el-input v-model.trim="formData.contactPerson"></el-input>
              </el-form-item>
              <el-form-item label="联系电话：">
                <el-input v-model.trim="formData.contactPhone"></el-input>
              </el-form-item>
              <el-form-item label="工商注册号：">
                <el-input v-model.trim="formData.registrationSn"></el-input>
              </el-form-item>
              <el-form-item label="行业类型：">
                <el-select v-model="formData.type" placeholder="请选择行业类型" style="width: 100%">
                  <el-option v-for="(item, index) in typeArr" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <button class="BlueSmBtn" type="primary" @click="cancel" style="background:#2f364e;">取消</button>
              <button class="BlueSmBtn" type="primary" @click="confirm">确定</button>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { regionData, CodeToText } from 'element-china-area-data'
export default {
  data() {
    return {
      showTable: true,
      dataInfo: {},
      showInfo: {},
      tabName: 'jsgl',
      formInfo: {},
      showFrom: true,
      formData: {
        name: '',
        shortName: '',
        address: '',
        contactPerson: '',
        contactPhone: '',
        registrationSn: '',
        type: undefined
      },
      options: regionData,
      typeArr: [
        {
          label: '社区',
          value: 1
        },
        {
          label: '高校',
          value: 2
        },
        {
          label: '工业',
          value: 3
        },
        {
          label: '其他',
          value: 9
        }
      ]
    }
  },
  components: {},
  methods: {
    getInfo() {
      this.showTable = false
      this.$axiosget(
        'manager/company/getInfo?companyId='.concat(
          localStorage.getItem('companyId')
        )
      ).then((res) => {
        let data = res.data.data
        let areaTitle = ''
        if (data.areaIds.length === 1) {
          areaTitle = CodeToText[data.areaIds[0]]
        } else if (data.areaIds.length === 2) {
          areaTitle = CodeToText[data.areaIds[0]].concat([data.areaIds[1]])
        } else if (data.areaIds.length === 3) {
          areaTitle = CodeToText[data.areaIds[0]].concat(
            CodeToText[data.areaIds[1]],
            CodeToText[data.areaIds[2]]
          )
        }
        this.showInfo = { ...res.data.data, areaTitle }
        this.dataInfo = res.data.data
      })
    },
    clone(src, target) {
      src.name = target.name
      src.shortName = target.shortName
      src.areaIds = target.areaIds
      src.address = target.address
      src.contactPerson = target.contactPerson
      src.contactPhone = target.contactPhone
      src.registrationSn = target.registrationSn
      src.type = target.type
    },
    edit() {
      this.clone(this.formData, this.dataInfo)
      this.showFrom = false
    },
    cancel() {
      this.showFrom = true
    },
    confirm() {
      this.$axiospost('manager/company/addOrUpdateCompany', {
        ...this.formData,
        id: this.dataInfo.id
      }).then((res) => {
        this.$message.success('修改成功！')
        this.showFrom = true
        this.getInfo()
      })
    }
  },
  mounted() {
    this.getInfo()
  }
}
</script>

<style lang="less" >
.info {
  div {
    margin-bottom: 20px;
    color: #ccc;
    font-size: 14px;
  }
}
.dialog-footer {
  text-align: right;
}
.cominfoForm {
  .el-cascader {
    width: 100%;
  }
  .el-form-item {
    background: transparent;
    color: #cacaca;
    .el-form-item__label {
      color: #ccc;
    }
    .el-input {
      .el-input__inner {
        background: transparent;
        color: #cacaca;
        border: 1px solid #3d4963;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/basic/info/index.vue